import { pxToRem } from '../../../../utils';
import submenuIndicatorUrl from './submenuIndicatorUrl';
var menuItemIndicatorStyles = {
  root: function root(_ref) {
    var p = _ref.props,
        v = _ref.variables,
        rtl = _ref.rtl;
    return Object.assign({
      position: 'relative',
      float: 'right',
      left: pxToRem(12),
      userSelect: 'none',
      marginRight: pxToRem(4)
    }, p.inSubmenu && {
      position: 'absolute',
      top: pxToRem(6),
      right: pxToRem(2),
      left: 'unset'
    }, {}, rtl && {
      transform: "scaleX(-1)"
    }, {
      content: '" "',
      display: 'block',
      overflow: 'hidden',
      height: pxToRem(16),
      width: pxToRem(16),
      backgroundImage: submenuIndicatorUrl(v.indicatorColor, p.vertical)
    }, p.active && Object.assign({
      backgroundImage: submenuIndicatorUrl(v.activeIndicatorColor, p.vertical)
    }, p.primary && Object.assign({
      backgroundImage: submenuIndicatorUrl(v.activePrimaryIndicatorColor, p.vertical)
    }, p.vertical && {
      backgroundImage: submenuIndicatorUrl(v.activePrimaryVerticalIndicatorColor, p.vertical)
    })), {}, p.underlined && {
      backgroundImage: submenuIndicatorUrl(v.indicatorColor, p.vertical)
    }, {}, p.iconOnly && {
      backgroundImage: submenuIndicatorUrl(v.indicatorColor, p.vertical)
    });
  }
};
export default menuItemIndicatorStyles;
//# sourceMappingURL=menuItemIndicatorStyles.js.map
